<template>
  <el-dialog title="新建/编辑" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="上级地址" :prop="isParentid?'parentCode':''">
        <treeselect v-model="form.parentCode" :disabled="form.id && !form.parentCode" :options="menuOptions" :normalizer="normalizer" :show-count="true" noOptionsText="暂无数据" placeholder="请选择" />
      </el-form-item>
      <el-form-item label="编码" prop="regionCode">
        <el-input v-model="form.regionCode" />
      </el-form-item>
      <el-form-item label="名称" prop="regionName">
        <el-input v-model="form.regionName" />
      </el-form-item>
      <el-form-item label="省市区" prop="regionType">
        <el-radio-group v-model="form.regionType">
          <el-radio :label="0">国家</el-radio>
          <el-radio :label="1">省</el-radio>
          <el-radio :label="2">市</el-radio>
          <el-radio :label="3">区</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false"> 取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysAddrApi from '@/api/system/sysAddr'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
function initFormBean() {
  const formBean = {
    parentCode: null,
    regionCode: null,
    regionName: null,
    regionType: 3,
    sort: 0,
  }
  return formBean
}

export default {
  props: ['menuOptions'],
  components: { Treeselect },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        regionCode: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        regionName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        regionType: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      isParentid: false,
      isRepSub: false
    }
  },
  created() {
  },
  methods: {
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.regionCode,
        label: node.regionName,
        children: node.children
      };
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.isParentid = false
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      if (row.id && row.parentCode) this.isParentid = true
      row.parentCode = row.parentCode || null
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.sort = params.sort || 0
      params.parentCode = params.parentCode || 0
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            sysAddrApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            sysAddrApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
